<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Get Lit</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Kim Fielding</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Uri Kessler is a bit of a klutz. Recently divorced from a guy he married too quickly and yearning to have a holiday that feels special, he decides to make Hanukkah candles. The results are literally a blazing disaster. But Uri’s mishap helps him get to know Oscar Cortez, his sexy new neighbor, and the two men instantly hit it off. While Uri finds himself drawn to Oscar, he’s also afraid to make a mess of their budding relationship. It’ll take a small miracle to make things work between them.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?3795309e